<template>
    <li class="sku-item">
        <a :href="'/pages/product_detail/sku_detail/sku_detail.html?proid='+itemP.productId+'&isQuick='+itemP.speedUp" class="analysis" data-analysis="进入商品详情">
            <template v-for="(pic,index) in itemP.picMap.picProductSmall" v-if="index<=0">
                <img :src="pic">
            </template>
        </a>
        <div class="sku-info">
            <h3>{{itemP.productName}}</h3>
            <p>{{itemP.proSummary}}</p>
        </div>
        <div class="sku-opera">
            <p class="sku-price">
                <span class="sku-origin-price" style="text-decoration: line-through;">原价¥{{itemP.originPrice}}/{{itemP.productUnit}}</span>
                <span class="sku-fact-price">
                    <b :class="'sku-'+vipDay+'-price'" :style="{display:vipDay=='isvipday'&&vipLevel>0?'inline-block':'none'}" v-html="vipLevel>0?'V'+vipLevel+'<em>价</em>':''"></b>
                    <em class="sku-price-count">¥{{itemP.salePrice}}/{{itemP.productUnit}}</em>
                </span>
            </p>
            <proOpera :itemPro="itemP" :speedUp="itemP.speedUp" :stockCount="itemP.speedupStockNum" :proId="itemP.productId" :promoId="itemP.promotionId" :protype="4" :proLimit="itemP.limitBuyCount" :proName="itemP.productName"></proOpera>
        </div>
        <span class="speed-tips" v-if="itemP.speedUp=='1'"></span>
        <span class="store-tips" v-else :class="'pro-delay-'+setId(itemP.speedUp)+itemP.productId" ></span>

    </li>
</template>

<script>
    import proOpera from '@/components/index/product_opera.vue'

    export default{
        props:['itemP','vipLevel','vipDay'],
        components:{
            proOpera
        },
        mounted(){

        },
        methods:{
            setId(item){
                return item!=undefined?item+'-':''
            },
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../resource/css/color";
    /**sku**/
    .sku-content, .milk-content {
        background: #ffffff;
    }

    .sku-item {
        position: relative;
        width: 50%;
        float: left;
        background: #ffffff;
        box-sizing: border-box;
        padding: .2rem .2rem .45rem;
        border-right: 1px solid #f2f2f2;
        border-bottom: 1px solid #f2f2f2;
        height: 5.0rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-box-pack: justify;
    }

    .sku-item a img {
        width: 2.4rem;
        display: block;
        margin: 0 auto .1rem;
    }

    .sku-info {
        height: 1.1rem;
        margin-bottom: .2rem;
    }

    .sku-info h3 {
        font-size: .26rem;
        margin-bottom: .05rem;
        font-weight: normal;
    }

    .sku-info p {
        font-size: .22rem;
        color: #666666;
    }

    .sku-opera {
        display: -webkit-box;
        -webkit-box-pack: justify;
        -webkit-box-align: end;
    }

    .sku-price {
        position: relative;
        color: #e50011;
        padding-top: .36rem;
        width: 1.5rem;
        -webkit-box-flex: 1;
        font-size: .26rem;
    }

    .sku-price span {
        display: block;
    }

    .sku-origin-price {
        position: absolute;
        top: .06rem;
        left: 0;
        color: rgb(239, 102, 112);
        font-size: .2rem;
    }

    .sku-fact-price {
        color: #e50011;
        font-size: .26rem;
    }

    .sku-fact-price b {
        display: none;
        font-size: .22rem;
        color: #ffffff;
        width: .55rem;
        height: .31rem;
        background: url('./images/index-price-bg.png') top left no-repeat;
        background-size: .55rem auto;
        margin-right: .03rem;
        font-weight: normal;
        text-align: center;
        line-height: .32rem;
    }

    .sku-fact-price b em {
        font-size: .18rem;
        margin-right: .02rem;
    }

    .sku-fact-price > i {
        font-style: normal;
        position: relative;
        top: .02rem;
    }

    .sku-fact-price .sku-price-count {
        font-style: normal;
        position: relative;
        top: .02rem;
        font-size: .24rem;
    }

    .sku-item .sku-notvipday-price {
        display: none;
    }
    .speed-tips{
        position: absolute;
        top:0;
        left: .2rem;
        width: .56rem;
        height:.66rem;
        display: block;
        background: url("./images/speed-icon.png") top left no-repeat;
        background-size: .56rem .66rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/module_pro/sku.vue